import { createApi } from '@reduxjs/toolkit/query/react';
import { urls } from '../../utils/helpers/ApiClient';
import axiosFetchBase from '../axiosFetchBase';

export const ingProjectsPanelStoryApi = createApi({
  reducerPath: 'ingProjectsPanelStoryApi',
  baseQuery: axiosFetchBase,
  tagTypes: ['IpPanelStory', 'IpPanelStoryList'],
  endpoints: (builder) => ({
    getPanelStoryList: builder.query({
      query: () => ({
        url: urls.ingProjectsPanelStoryList,
        method: 'GET',
      }),
      providesTags: ['IpPanelStoryList'],
    }),
    getPanelStory: builder.query({
      query: (projectId) => ({
        url: urls.ingProjectsPanelStory(projectId),
        method: 'GET',
      }),
      providesTags: (result, error, projectId) => [{ type: 'IpPanelStory', id: projectId }],
    }),
    savePanelStory: builder.mutation({
      query: ({ projectId, ...data }) => ({
        url: urls.ingProjectsPanelStory(projectId),
        method: 'POST',
        data,
      }),
      invalidatesTags: (result, error, { projectId }) => [
        { type: 'IpPanelStory', id: projectId },
        'IpPanelStoryList',
      ],
    }),
    exportPanelStoryXls: builder.mutation({
      query: () => ({
        url: urls.ingProjectsSettingsExportPanelStory,
        method: 'GET',
      }),
    }),
    exportPanelStoryMissingXls: builder.mutation({
      query: () => ({
        url: urls.ingProjectsSettingsExportPanelStoryMissing,
        method: 'GET',
      }),
    }),
  }),
});

export const {
  useGetPanelStoryListQuery,
  useGetPanelStoryQuery,
  useSavePanelStoryMutation,
  useExportPanelStoryXlsMutation,
  useExportPanelStoryMissingXlsMutation,
} = ingProjectsPanelStoryApi;
